
import ActionsHeader from '@/components/ActionsHeader.vue';

export default {
    name: 'BandeauHeader',
    components: { ActionsHeader }
};
